// packages
import { Helmet } from "react-helmet-async";

// components (template)
import Hero from "../../components/Hero";

// data
import { hero, meta } from "../../data/pages/terms";

export default function Terms() {
  return (
    <>
      <Helmet>
        <title>{meta.title} - Ninacci</title>
        <meta
          name="description"
          content={meta.description}
        />
      </Helmet>
      <Hero
        title={meta.title}
        image={hero.image}
        content={hero.contents}
      />
    </>
  );
}
